import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["error", "button"]
  static values = { updateUrl: String }

  select(event) {
    const brandStyleId = event.currentTarget.dataset.brandStyleId
    if (!brandStyleId) return

    this.setButtonsDisabled(true)
    if (this.hasErrorTarget) this.errorTarget.classList.add("hidden")

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.updateUrlValue, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
      },
      body: new URLSearchParams({ brand_style_id: brandStyleId }),
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (ok && data.status === "success") {
          if (window.Turbo) {
            window.Turbo.visit(window.location.href, { action: "replace" })
          } else {
            window.location.reload()
          }
        } else {
          this.setButtonsDisabled(false)
          if (this.hasErrorTarget) this.errorTarget.classList.remove("hidden")
        }
      })
      .catch(() => {
        this.setButtonsDisabled(false)
        if (this.hasErrorTarget) this.errorTarget.classList.remove("hidden")
      })
  }

  setButtonsDisabled(disabled) {
    this.buttonTargets.forEach((button) => {
      button.disabled = disabled
    })
  }
}
